import React from "react";
import "../Spinner/Spinner.css";
// @name SpinBar
// @desc to get SpinBar with on a screen.
// @author Sahithi
function SpinBar() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}

export default SpinBar;
